import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { Observable } from 'rxjs';
import { AuthcodeGenerateCodeResponseDto } from '../../dto';

@Injectable({
    providedIn: 'root',
})
export class AuthcodeApiService {
    constructor(private baseApiService: BaseApiService) { }

    generateCode(userId: number): Observable<AuthcodeGenerateCodeResponseDto> {
        return this.baseApiService.post('service/contactcloud/authcode/one-time-code/generate', null, {
            params: { userId },
            showError: true,
        });
    }
}
